import { useCallback } from 'react';
import {
  useGetKeyValueSettings,
  useKeyValueSettingsMutation,
  updateCache
} from '~/modules/common/hooks';

export const ALLOCATE_RESOURCE_DIALOG_SETTINGS_KEY =
  'allocate_resource_dialog_settings';

export const useAllocateResourceDialogSettings = () => {
  const { isLoading, keyValueSettings } = useGetKeyValueSettings(
    ALLOCATE_RESOURCE_DIALOG_SETTINGS_KEY
  );

  return {
    isLoading,
    dialogSettings: keyValueSettings
  };
};

export const usePutAllocateResourceDialogSettings = () => {
  const [putKeyValueSettings] = useKeyValueSettingsMutation(
    updateCache(ALLOCATE_RESOURCE_DIALOG_SETTINGS_KEY)
  );

  const putAllocateResourceDialogSettings = useCallback(
    ({ showAdvancedSettings, selectedAllocationPeriod, displayUnit }) => {
      putKeyValueSettings({
        variables: {
          input: {
            key: ALLOCATE_RESOURCE_DIALOG_SETTINGS_KEY,
            settings: {
              showAdvancedSettings,
              selectedAllocationPeriod,
              displayUnit
            }
          }
        },
        context: {
          debounceKey: ALLOCATE_RESOURCE_DIALOG_SETTINGS_KEY
        }
      });
    },
    [putKeyValueSettings]
  );

  return {
    putAllocateResourceDialogSettings
  };
};
